import { createReducer, on } from '@ngrx/store';

import { VersionStoreModel } from '@domain/metadata';

import { MetaDataActions } from './meta-data.actions';

export const featureKey = 'meta-data';

export interface FeatureState {
  versions?: VersionStoreModel;
}

const initialState: FeatureState = {
  versions: undefined,
};

export const metadataReducer = createReducer(
  initialState,
  on(MetaDataActions.getVersionSuccess, (state, { versions }): FeatureState => ({ ...state, versions }))
);
